import React, { useState, useEffect } from 'react';

import DashboardContainer from '../../components/admin/DashboardContainer';
import StudentsList from '../../components/admin/StudentsList';
import { supabase } from '../../supabaseClient';

export default function Students() {
  const [companies, setCompanies] = useState([]);
  const [studentsByCompany, setStudentsByCompany] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: companiesData, error: companiesError } = await supabase
          .from('companies')
          .select('*')
          .order('name');

        if (companiesError) {
          console.error('Error fetching companies:', companiesError);
        } else {
          setCompanies(companiesData);
        }

        const studentsDataPromises = companiesData.map(async (company) => {
          const { data: studentsData, error: studentsError } = await supabase
            .from('users')
            .select(`*, company:companies(*), user_activities(*)`)
            .eq('role', 'student')
            .eq('company', company.id)
            .order('score', { ascending: false });

          if (studentsError) {
            console.error(`Error fetching students for company ${company.name}:`, studentsError);
            return [];
          }

          return studentsData;
        });

        const studentsData = await Promise.all(studentsDataPromises);
        setStudentsByCompany(studentsData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <DashboardContainer title={'Estudiantes'}>
      {companies.map((company, index) => (
        <div key={company.id}>
          <h2>{company.name}</h2>
          
          <StudentsList students={studentsByCompany[index]} showCompany={false} />
        </div>
      ))}
    </DashboardContainer>
  );
}